export default "__VITE_ASSET__cFkc56rT__"